/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon24Solid = forwardRef('NumberCircle07Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm3.515-14.898h-7.07V8.67h4.928a22.855 22.855 0 0 0-2.296 4.032c-.653 1.465-1.073 2.898-1.26 4.298h2.086c.215-1.54.653-3.066 1.316-4.578.663-1.512 1.428-2.814 2.296-3.906V7.102Z" })));
});
